// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mobileLogo_wrapper__ZMF86","dataWrapper":"mobileLogo_dataWrapper__FX1JE"};